import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';

import firebase from 'firebase/app';
require("firebase/firestore");

const styles = theme => ({
  root: {
    height: '100vh',
    width: '100vw',
    textAlign: 'center',
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  field: {
    minWidth: 200,
    textAlign: 'start',
  }
});

class LoginPage extends Component {
  state = {
    showProgress: false,
    showMessage: false,
    message: '',
  };

  handleRequestClose = () => {
    this.setState({ showMessage: false });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleKeyPress = (target) => {
    if (target.charCode === 13) {
      this.login();
    }
  }

  login = () => {
    this.setState({ showProgress: true, });

    firebase.auth()
      .signInWithEmailAndPassword(this.state.email, this.state.pw)
      .then(() => {
        this.setState({ showProgress: false, });
      })
      .catch(error => {
        this.setState({
          showProgress: false,
          showMessage: true,
          message: error.message,
        });
      });
  };

  render() {
    const { classes } = this.props;

    return(
      <div>
        <LinearProgress style={{ visibility: (this.state.showProgress ? 'visible' : 'hidden') }} />

        <div className={classes.root}>
          <Typography
            variant="h3"
            color="textSecondary"
            noWrap
            style={{ padding: "8px 0", fontFamily: 'Montserrat' }}>
            MyBASE Admin
          </Typography>
          <br/>
          <TextField
            className={classes.field}
            autoFocus
            id="email"
            label="Email"
            margin="normal"
            defaultValue={this.state.email}
            onChange={this.handleChange('email')}
            onKeyPress={this.handleKeyPress}
          />
          <br/>
          <TextField
            className={classes.field}
            id="password"
            label="Password"
            type="password"
            autoComplete="off"
            margin="normal"
            defaultValue={this.state.pw}
            onChange={this.handleChange('pw')}
            onKeyPress={this.handleKeyPress}
          />
          <br/>
          <br/>
          <br/>
          <Button
            id="login"
            disabled={
              !this.state.email ||
              !this.state.pw
            }
            color="primary"
            onClick={this.login} >
            LOGIN
          </Button>

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            autoHideDuration={5000}
            open={this.state.showMessage}
            onClose={this.handleRequestClose}
            message={<span id="message-id">{this.state.message}</span>}
          />
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginPage);
